import * as Turbo from "@hotwired/turbo"
import * as echarts from "echarts"
import EChartsController from "../../echarts_controller"
import { Categories } from "./helper"

export default class extends EChartsController {
  static values = {
    datesCategories: { type: Object, default: {} },
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)

    const year = Number(target.dataset.year)
    this.renderChart(this.chart, this.datesCategoriesValue, year)

    target.addEventListener("calendar:resize", () => {
      const instance = echarts.getInstanceByDom(target)
      if (instance) requestAnimationFrame(() => instance.resize())
    })
  }

  renderChart(chart, datesCategories, year) {
    const yearDatesCategories = {}

    Object.keys(datesCategories).forEach((dateString) => {
      const dateYear = parseInt(dateString.split("-")[0])

      if (dateYear === year) {
        yearDatesCategories[dateString] = datesCategories[dateString]
      }
    })

    const getVirtualData = () => {
      const data = []

      const date = +echarts.number.parseDate(year + "-01-01")
      const end = +echarts.number.parseDate(+year + 1 + "-01-01")
      const dayTime = 3600 * 24 * 1000

      for (let time = date; time < end; time += dayTime) {
        const dateString = echarts.format.formatTime("yyyy-MM-dd", time)
        const topCategoryPrecedence = (yearDatesCategories[dateString] || [])[0]

        data.push([dateString, topCategoryPrecedence || 0])
      }

      return data
    }

    const getTooltip = (arg) => {
      const dateCategories = yearDatesCategories[arg.value[0]]

      if (dateCategories) {
        if (dateCategories[0] == 1) {
          return `
        <div>${arg.value[0]}</div>
        <strong>Predicted by Augur</strong>
      `
        } else {
          return `
        <div>${arg.value[0]}</div>
        <span>Reported as: ${dateCategories.map((category) => Categories[category]).join(", ")}</span>
      `
        }
      }
    }

    const getOption = () => {
      return {
        tooltip: {
          formatter: function (params) {
            return getTooltip(params)
          },
          confine: true,
        },

        visualMap: {
          show: false,
          min: 0,
          max: 5000,
          type: "piecewise",
          orient: "horizontal",
          left: "left",
          top: 5,
          pieces: [
            { min: 1, max: 1, color: "#00F5E9" },

            { min: 2, max: 2, color: "#FF1744" },
            { min: 3, max: 3, color: "#FF1744" },
            { min: 4, max: 4, color: "#FF1744" },
            { min: 5, max: 5, color: "#FF1744" },
            { min: 6, max: 6, color: "#FF1744" },
            { min: 7, max: 7, color: "#FF1744" },

            { min: 8, max: 8, color: "#FFD600" },
            { min: 9, max: 9, color: "#FFD600" },
            { min: 10, max: 10, color: "#3D5AFE" },
            { min: 11, max: 11, color: "#FFD600" },
            { min: 12, max: 12, color: "#FFD600" },
            { min: 13, max: 13, color: "#FFD600" },
            { min: 14, max: 14, color: "#FFD600" },
            { min: 15, max: 15, color: "#FFD600" },
            { min: 16, max: 16, color: "#FFD600" },

            { min: 17, max: 17, color: "#FF6D00" },
            { min: 18, max: 18, color: "#FF6D00" },
            { min: 19, max: 19, color: "#FF6D00" },
            { min: 20, max: 20, color: "#FF6D00" },
            { min: 21, max: 21, color: "#FF6D00" },
            { min: 22, max: 22, color: "#FF6D00" },
            { min: 23, max: 23, color: "#FF6D00" },
            { min: 24, max: 24, color: "#FF6D00" },
          ],
        },
        calendar: {
          top: 20,
          left: 25,
          right: 0,
          bottom: 0,
          cellSize: 17,
          range: year,
          splitLine: {
            lineStyle: {
              width: 0.5,
              color: "#19324C",
              type: "solid",
            },
          },
          itemStyle: {
            borderWidth: 0.5,
            borderColor: "#19324C",
            color: "transparent",
          },
          dayLabel: {
            color: "#B6C7D8",
          },
          monthLabel: {
            color: "#B6C7D8",
          },
          yearLabel: {
            show: false,
          },
        },
        series: {
          type: "heatmap",
          coordinateSystem: "calendar",
          data: getVirtualData(),
        },
      }
    }

    const onClick = (params) => {
      const date = params.value[0]
      const url = new URL(window.location)
      url.searchParams.set("date", date)
      Turbo.visit(url)
    }

    chart.setOption(getOption())
    chart.on("click", onClick)
  }
}
